<template>
  <div class="products-group">
    <products
    v-for="item in product" :key="item.name"
    :product="item" :id="groupname"/>
  </div>
</template>

<script>
import products from '@/components/products_card.vue';

export default {
  components: {
    products,
  },
  props: {
    productList: {
      type: Object,
      default: () => ({
        groupname: '感測器',
        group: [
          {
            no: 1,
            scrollNav: true,
            groupname: '感測器',
            DMdownload: '',
            productName: 'LoRaWAN環境感知感應器集中器(LoRa1485)',
            description: 'LoRaWAN環境感知感應器集中器(Linkit 7697、LoRaWAN通訊、WiFi通訊、太陽能板；空氣溫濕度光照度感測器、土壤溫溼度/氮磷鉀/酸鹼值感測器各1個。',
            componentList: [
              {
                component: 'LoRa模組：',
                spec: [
                  'Compliance to LoRaWAN 1.0.2',
                  'Built-in antenna with IPEX connector',
                  'Command set with LoRaWAN chip for easy configuration',
                  'LoRa Frequency Band: 920 ~ 925MHz ISM',
                  'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                  'LoRa Receive Sensitivity: -130dBm',
                  'Operating Temperature: -10ºC ~ 55ºC',
                  'LoRa Number of Channels: Configurable 8 channels',
                  'LoRa Security: AES 128',
                  'Storage Temperature: -10ºC ~ 60ºC',
                ],
              },
              {
                component: '土壤溫溼度/電導度感應器：',
                spec: [
                  '直流供電: 3.6~30VDC',
                  '最大功耗:0.4w ',
                  '精準度:土壤濕度±3%,土壤溫度±0.5攝氏',
                  '土壤電導率±3% ',
                  '土壤溫度量程:-40~80攝氏',
                  '土壤濕度量程:0%RH~100%RH ',
                  '土壤電導度量程:0-10000us/cm',
                  '通訊方式: RS485',
                ],
              },
            ],
            pictures: [
              'https://picsum.photos/600/300?random=1',
              'https://picsum.photos/600/300?random=2',
              'https://picsum.photos/600/300?random=3',
              'https://picsum.photos/600/300?random=4',
            ],
          },
          {
            no: 2,
            scrollNav: false,
            DMdownload: '',
            productName: '土壤感測器組(LoRa2485) / (NB4485)',
            description: '(1)LoRa或NB-IoT通訊模組、藍芽晶片、太陽能板、鋰電池、土壤感測器一支。(2)可選配共二支土壤感測器。',
            componentList: [
              {
                component: 'LoRa模組：',
                spec: [
                  'Compliance to LoRaWAN 1.0.2',
                  'Built-in antenna with IPEX connector',
                  'Command set with LoRaWAN chip for easy configuration',
                  'LoRa Frequency Band: 920 ~ 925MHz ISM',
                  'LoRa Transmit Power : 0.1W (up to 20 dBm)',
                  'LoRa Receive Sensitivity: -130dBm',
                  'Operating Temperature: -10ºC ~ 55ºC',
                  'LoRa Number of Channels: Configurable 8 channels',
                  'LoRa Security: AES 128',
                  'Storage Temperature: -10ºC ~ 60ºC',
                ],
              },
              {
                component: '藍芽晶片：(nRF52832)',
                spec: [
                  'SoC效能至少2.4GHz以上',
                  '256KB/128KB快閃記憶體+32KB/16KB RAM',
                  '工作溫度範圍：-40℃至+105℃',
                  '電壓範圍：1.7V至3.6V',
                  '192kB快閃記憶體+ 24kB RAM',
                ],
              },
              {
                component: '土壤溫溼度/電導度感應器：',
                spec: [
                  '直流供電: 3.6~30VDC',
                  '最大功耗:0.4w ',
                  '精準度:土壤濕度±3%,土壤溫度±0.5攝氏',
                  '土壤電導率±3% ',
                  '土壤溫度量程:-40~80攝氏',
                  '土壤濕度量程:0%RH~100%RH ',
                  '土壤電導度量程:0-10000us/cm',
                  '通訊方式: RS485',
                ],
              },
            ],
            pictures: [
              'https://picsum.photos/600/300?random=5',
              'https://picsum.photos/600/300?random=6',
              'https://picsum.photos/600/300?random=7',
              'https://picsum.photos/600/300?random=8',
            ],
          },
        ],
      }),
    },
  },
  data() {
    return {
      product: this.productList.group,
      groupname: this.productList.groupname,
    };
  },
  methods: {
    download() {
      // eslint-disable-next-line no-alert
      window.alert('DM尚未上傳');
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
